import { useMutation } from '@tanstack/react-query'
import { payWithCreditCardApi } from '@!/Api/externalPayment'

/**
 * クレジットカード決済のカスタムフック
 * @returns {Object} 決済関数とステート
 */
export const useCreditCardPurchase = () => {
  const mutation = useMutation({
    mutationFn: (productId) => payWithCreditCardApi(productId),
  })

  return {
    purchaseWithCredit: mutation.mutateAsync,
    isLoading: mutation.isPending,
  }
}
